import { render, staticRenderFns } from "./LoginAgain.vue?vue&type=template&id=f2fc4142&"
import script from "./LoginAgain.vue?vue&type=script&lang=js&"
export * from "./LoginAgain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "LoginAgain.vue"
export default component.exports